import * as React from 'react';
import getLangTranslation from '../../common/lang-trans';
import { SurveyModel } from '../../models/survey.model';
import ReactMarkdown from 'react-markdown';

interface iProps {
    survey: SurveyModel,
    moveNextStep: any,
    language: string
}

class SurveyStart extends React.PureComponent<iProps> {

    public render() {
        const startNotes = this.props.survey.startNotes || '';
        const language = this.props.language || 'en';
        const langTrans = getLangTranslation(language);
        return (
            <React.Fragment>
                <div className="row" >
                    <div className="col-sm-12">
                        <ReactMarkdown children={startNotes} />
                    </div>
                    <div className="col-sm-12">
                        <button className="btn btn-primary"
                            onClick={() => this.props.moveNextStep(undefined)}>{langTrans.Continue}</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

};

export default SurveyStart;
